// import { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ChartIcon, ImportIcon, ShieldIcon, BatteryIcon, ScaleIcon, CycleIcon } from "../Icons";

// function MarketPage() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const reveals = document.querySelectorAll(".reveal");
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((e) => {
//         if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
//       });
//     }, { threshold: 0.1 });
//     reveals.forEach((r) => observer.observe(r));
//     return () => observer.disconnect();
//   }, []);

//   const dataPoints = [
//     { label: "EV Penetration Growth", value: "+42% CAGR", width: "84%", color: "var(--green)" },
//     { label: "Battery Recycling Market Size by 2030", value: "$5B+", width: "72%", color: "var(--green)" },
//     { label: "Critical Mineral Import Dependency", value: "90%+", width: "90%", color: "var(--amber)" },
//     { label: "EPR Compliance Mandate", value: "Active Now", width: "100%", color: "var(--green)" },
//     { label: "EV Units Sold FY2023", value: "1.5M+", width: "55%", color: "var(--green)" },
//     { label: "Battery Waste Unrecycled (Current)", value: "> 95%", width: "95%", color: "var(--amber)" },
//   ];

//   return (
//     <main style={{ paddingTop: "80px" }}>

//       {/* PAGE HERO */}
//       <section className="page-hero">
//         <div className="hero-grid-bg"></div>
//         <div className="hero-glow" style={{ opacity: 0.4 }}></div>
//         <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
//           <div className="section-tag">Market Opportunity</div>
//           <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
//             The Opportunity<br />Is Enormous
//           </h1>
//           <p className="section-body" style={{ maxWidth: "620px" }}>
//             India's EV transition is creating a massive, urgent, and underserved battery recycling gap. We're positioned at the centre of it — and the numbers tell the story clearly.
//           </p>
//         </div>
//       </section>

//       {/* MARKET METRICS */}
//       <section>
//         <div className="section-inner">
//           <div className="section-tag">By the Numbers</div>
//           <h2 className="section-title display">Market at a Glance</h2>
//           <div className="market-bars reveal" style={{ marginTop: "3rem", maxWidth: "700px" }}>
//             {dataPoints.map((d) => (
//               <div key={d.label}>
//                 <div className="mbar-label">
//                   <span>{d.label}</span>
//                   <span style={{ color: d.color, fontFamily: "'DM Mono', monospace" }}>{d.value}</span>
//                 </div>
//                 <div className="mbar-track">
//                   <div className="mbar-fill" style={{ width: d.width, background: `linear-gradient(90deg, ${d.color}, ${d.color}aa)` }}></div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* THREE MARKET FORCES */}
//       <section style={{ background: "var(--panel)" }}>
//         <div className="section-inner">
//           <div className="section-tag">Market Drivers</div>
//           <h2 className="section-title display">Three Forces Converging</h2>

//           <div className="page-pillar-grid reveal">

//             <div className="page-pillar-card">
//               <div className="page-pillar-icon"><ChartIcon size={44} /></div>
//               <h3>Exponential EV Adoption</h3>
//               <p>
//                 India's EV market is growing at over 40% CAGR, driven by government subsidies (FAME II, PLI), rising fuel costs, and improving battery economics. By 2030, tens of millions of EVs will be on Indian roads — each carrying a battery that will eventually need recycling.
//               </p>
//               <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">42%</span>
//                   <span className="ppd-stat-label">EV CAGR</span>
//                 </div>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">2030</span>
//                   <span className="ppd-stat-label">Peak waste arrival</span>
//                 </div>
//               </div>
//             </div>

//             <div className="page-pillar-card">
//               <div className="page-pillar-icon"><ImportIcon size={44} /></div>
//               <h3>Critical Mineral Scarcity</h3>
//               <p>
//                 India imports over 90% of the lithium, cobalt, and nickel required for battery manufacturing — primarily from geopolitically volatile regions. The government has identified critical mineral self-sufficiency as a national priority. Domestic recycling is the fastest and most economic path to reducing this dependency.
//               </p>
//               <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">$5B+</span>
//                   <span className="ppd-stat-label">Recycling market by 2030</span>
//                 </div>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">90%+</span>
//                   <span className="ppd-stat-label">Minerals imported today</span>
//                 </div>
//               </div>
//             </div>

//             <div className="page-pillar-card">
//               <div className="page-pillar-icon"><ShieldIcon size={44} /></div>
//               <h3>Mandatory EPR Compliance</h3>
//               <p>
//                 The Battery Waste Management Rules 2022 make Extended Producer Responsibility mandatory for every battery producer, importer, and brand owner in India. Targets scale annually. Non-compliance triggers financial penalties and reputational risk. Every OEM in India now legally requires a certified recycling partner.
//               </p>
//               <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">2022</span>
//                   <span className="ppd-stat-label">EPR rules live</span>
//                 </div>
//                 <div className="ppd-stat">
//                   <span className="ppd-stat-num">100%</span>
//                   <span className="ppd-stat-label">OEMs affected</span>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* VALUE CHAIN */}
//       <section>
//         <div className="section-inner">
//           <div className="section-tag">Revenue Model</div>
//           <h2 className="section-title display">Where the Value Is</h2>
//           <p className="section-body">
//             Battery recycling is not a single revenue stream. We generate value at every stage of the process.
//           </p>

//           <div className="value-chain reveal">
//             {[
//               { icon: <BatteryIcon size={28} />, source: "Collection Fees", desc: "OEMs and producers pay a collection and processing fee per tonne for EPR-compliant disposal and certificate issuance." },
//               { icon: <CycleIcon size={28} />, source: "Black Mass Sales", desc: "High-grade Black Mass sold to hydrometallurgical refiners who extract Li, Co, Ni, Mn for battery remanufacturing." },
//               { icon: <ScaleIcon size={28} />, source: "Metal Recovery", desc: "Copper foil, aluminium foil, and steel casings sold to domestic smelters at commodity prices." },
//               { icon: <ChartIcon size={28} />, source: "EPR Certificate Trading", desc: "Surplus EPR certificates can be traded to producers who cannot meet their own collection targets — an emerging secondary market." },
//             ].map((v) => (
//               <div className="value-item" key={v.source}>
//                 <div className="value-icon">{v.icon}</div>
//                 <div>
//                   <h4>{v.source}</h4>
//                   <p>{v.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* POSITIONING */}
//       <section style={{ background: "var(--panel)" }}>
//         <div className="section-inner">
//           <div className="market-highlight" style={{ borderLeftColor: "var(--green)", maxWidth: "750px" }}>
//             Government EPR regulations now make battery recycling mandatory for producers — every OEM in India needs a certified recycling partner. <strong>That partner is us.</strong>
//           </div>
//           <p className="section-body" style={{ marginTop: "2rem" }}>
//             We are not chasing a speculative future market. The regulatory mandate is live, the waste stream is building, and the mineral value is real. Alankaar Power is positioned at the intersection of all three — with the processing capacity, compliance credentials, and operational infrastructure to capture it.
//           </p>
//         </div>
//       </section>

//       {/* CTA */}
//       <section style={{ borderTop: "var(--accent-line)" }}>
//         <div className="section-inner" style={{ textAlign: "center" }}>
//           <h2 className="section-title display">Invest in India's<br />Circular Future</h2>
//           <p className="section-body" style={{ margin: "0 auto 2rem" }}>
//             Whether you're an investor, an OEM, or a technology partner — the time to act is now.
//           </p>
//           <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
//             <a href="/#contact" className="btn-primary">Talk to Us</a>
//             <Link to="/" className="btn-outline">← Back to Home</Link>
//           </div>
//         </div>
//       </section>

//     </main>
//   );
// }

// export default MarketPage;



import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChartIcon, ImportIcon, ShieldIcon, BatteryIcon, ScaleIcon, CycleIcon } from "../Icons";

function MarketPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const reveals = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach((r) => observer.observe(r));
    return () => observer.disconnect();
  }, []);

  const dataPoints = [
    { label: "India EV Market CAGR (2022–2030, NITI Aayog)", value: "+49% CAGR", width: "98%", color: "var(--green)" },
    { label: "India Battery Recycling Market Size by 2030 (SAM)", value: "₹12,000–18,000 Cr", width: "78%", color: "var(--green)" },
    { label: "Critical Mineral Import Dependency (Li, Co, Ni)", value: "90%+", width: "90%", color: "var(--amber)" },
    { label: "EPR Compliance Mandate (BWMR 2022)", value: "Active — Enforced", width: "100%", color: "var(--green)" },
    { label: "EV Units Sold in India FY2023", value: "1.5M+", width: "55%", color: "var(--green)" },
    { label: "Battery Waste Currently Unrecycled", value: ">95%", width: "95%", color: "var(--amber)" },
    { label: "Li-ion Battery Waste — India (since 2022, CPCB)", value: "2,570 tonnes", width: "35%", color: "var(--green)" },
    { label: "Rajasthan Estimated Annual LIB Waste (Moderate)", value: "~1,065 t/yr", width: "42%", color: "var(--green)" },
  ];

  return (
    <main style={{ paddingTop: "80px" }}>

      {/* PAGE HERO */}
      <section className="page-hero">
        <div className="hero-grid-bg"></div>
        <div className="hero-glow" style={{ opacity: 0.4 }}></div>
        <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
          <div className="section-tag">Market Opportunity</div>
          <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
            The Opportunity<br />Is Enormous
          </h1>
          <p className="section-body" style={{ maxWidth: "620px" }}>
            India's EV transition is creating a massive, urgent, and underserved battery recycling gap. NITI Aayog projects India's EV market at 49% CAGR through 2030, with nearly 10 million annual EV sales by decade's end. We're positioned at the centre of the resulting waste stream — and the numbers tell the story clearly.
          </p>
        </div>
      </section>

      {/* MARKET METRICS */}
      <section>
        <div className="section-inner">
          <div className="section-tag">By the Numbers</div>
          <h2 className="section-title display">Market at a Glance</h2>
          <p className="section-body" style={{ maxWidth: "680px" }}>
            Data sourced from CPCB disclosures, NITI Aayog projections, and the Corpseed Detailed Project Report for our Jaipur facility.
          </p>
          <div className="market-bars reveal" style={{ marginTop: "3rem", maxWidth: "740px" }}>
            {dataPoints.map((d) => (
              <div key={d.label}>
                <div className="mbar-label">
                  <span>{d.label}</span>
                  <span style={{ color: d.color, fontFamily: "'DM Mono', monospace" }}>{d.value}</span>
                </div>
                <div className="mbar-track">
                  <div className="mbar-fill" style={{ width: d.width, background: `linear-gradient(90deg, ${d.color}, ${d.color}aa)` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TAM / SAM / SOM */}
      <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Market Sizing</div>
          <h2 className="section-title display">TAM · SAM · SOM</h2>
          <p className="section-body">
            The global and India-specific opportunity is well-defined and growing rapidly. Our addressable share is grounded in real facility capacity and regional geography.
          </p>
          <div className="page-pillar-grid reveal" style={{ marginTop: "3rem" }}>
            <div className="page-pillar-card">
              <div className="page-pillar-num">TAM</div>
              <h3>₹80,000 – 1,00,000 Crore</h3>
              <p>
                Total global lithium-ion battery recycling market — driven by rapid EV adoption worldwide, energy storage demand, and battery waste generation. Covers collection, recycling, and recovery of critical minerals globally across all geographies.
              </p>
            </div>
            <div className="page-pillar-card">
              <div className="page-pillar-num">SAM</div>
              <h3>₹12,000 – 18,000 Crore</h3>
              <p>
                Serviceable market in India for lithium battery recycling. Includes EV batteries, consumer electronics, and industrial battery waste. Growing at 25–30% CAGR with strong policy support from EPR mandates and India's EV push under FAME and PLI schemes.
              </p>
            </div>
            <div className="page-pillar-card">
              <div className="page-pillar-num">SOM</div>
              <h3>₹300 – 500 Crore</h3>
              <p>
                Achievable market share through our initial Jaipur plant and planned regional expansion into Delhi NCR and Gujarat. Revenue streams from Black Mass sales, metals recovery, EPR certificate services, and OEM partnerships. Operations scalable from 5 to 50 TPD.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THREE MARKET FORCES */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Market Drivers</div>
          <h2 className="section-title display">Three Forces Converging</h2>

          <div className="page-pillar-grid reveal">

            <div className="page-pillar-card">
              <div className="page-pillar-icon"><ChartIcon size={44} /></div>
              <h3>Exponential EV Adoption</h3>
              <p>
                NITI Aayog projects India's EV market to grow at 49% CAGR from 2022 to 2030, reaching nearly 10 million annual EV sales. India sold over 1.5 million EVs in FY2023 alone. With battery lifespans of 5–8 years, millions of batteries will enter end-of-life within this decade. Government schemes — FAME-I (₹895 Cr), FAME-II (₹11,500 Cr), and PM e-Drive (₹10,900 Cr, 2024–2026) — are accelerating adoption. The PLI Scheme for Advanced Chemistry Cells (₹18,100 crore) is further boosting local battery manufacturing.
              </p>
              <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">49%</span>
                  <span className="ppd-stat-label">EV CAGR to 2030</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">10M</span>
                  <span className="ppd-stat-label">Annual EVs by 2030</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">5–8yr</span>
                  <span className="ppd-stat-label">Battery lifespan</span>
                </div>
              </div>
            </div>

            <div className="page-pillar-card">
              <div className="page-pillar-icon"><ImportIcon size={44} /></div>
              <h3>Critical Mineral Scarcity</h3>
              <p>
                India imports over 90% of the lithium, cobalt, and nickel required for battery manufacturing — primarily from geopolitically volatile regions: DRC (70%+ of global cobalt), Chile (lithium brine), and China (refined materials). Global lithium consumption is 87% battery-driven. The National Critical Minerals Mission (NCMM) has allocated ₹1,500 crore to address supply chain dependency. Modern recycling technologies can recover 25%–96% of battery material — nearly 95% of a LIB can be recycled back into new batteries.
              </p>
              <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">₹1,500Cr</span>
                  <span className="ppd-stat-label">NCMM allocation</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">95%</span>
                  <span className="ppd-stat-label">LIB recyclability</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">90%+</span>
                  <span className="ppd-stat-label">Minerals imported</span>
                </div>
              </div>
            </div>

            <div className="page-pillar-card">
              <div className="page-pillar-icon"><ShieldIcon size={44} /></div>
              <h3>Mandatory EPR Compliance</h3>
              <p>
                The Battery Waste Management Rules 2022 (notified by MoEFCC) apply to all battery producers, importers, brand owners, and recyclers — regardless of chemistry, shape, volume, or weight. EPR collection targets have been live since 2023, scaling up significantly in 2025. Amendments in 2023, 2024, and 2025 tighten enforcement annually. Non-compliance triggers financial penalties and CPCB action. Every OEM in India now legally requires a certified, registered recycling partner.
              </p>
              <div className="ppd-stat-row" style={{ marginTop: "1.5rem" }}>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">2022</span>
                  <span className="ppd-stat-label">BWMR notified</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">2025</span>
                  <span className="ppd-stat-label">Targets scale up</span>
                </div>
                <div className="ppd-stat">
                  <span className="ppd-stat-num">100%</span>
                  <span className="ppd-stat-label">OEMs affected</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* RAJASTHAN LOCAL MARKET */}
      <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Local Market — Rajasthan</div>
          <h2 className="section-title display">The Feedstock Pipeline Is Building</h2>
          <p className="section-body">
            Jaipur and Rajasthan represent a strategically positioned and growing source of lithium-ion battery waste — across EV, consumer electronics, and energy storage segments. Estimates are based on CPCB data and standard DPR methodology for Rajasthan's ~5–6% national population share.
          </p>
          <div className="compare-table reveal" style={{ marginTop: "3rem" }}>
            <div className="compare-header">
              <div>Waste Source</div>
              <div className="compare-col-header">Conservative</div>
              <div className="compare-col-header">Moderate</div>
              <div className="compare-col-header alankaar">High</div>
            </div>
            {[
              ["Consumer Electronics (Phones, Laptops, Power Banks)", "300 t/yr", "900 t/yr", "1,500 t/yr"],
              ["Inverter / Residential ESS Batteries", "40 t/yr", "120 t/yr", "250 t/yr"],
              ["EV Battery Waste (2W / 3W / 4W)", "30 t/yr", "45 t/yr", "60 t/yr"],
              ["Total Estimated LIB Waste — Rajasthan", "370 t/yr", "1,065 t/yr", "1,810 t/yr"],
            ].map(([label, low, mid, high]) => (
              <div className="compare-row" key={label}>
                <div className="compare-label">{label}</div>
                <div className="compare-val">{low}</div>
                <div className="compare-val">{mid}</div>
                <div className="compare-val pos">{high}</div>
              </div>
            ))}
          </div>
          <p className="section-body" style={{ marginTop: "1.5rem", fontSize: "0.9rem", opacity: 0.7 }}>
            Source: Corpseed DPR for Alankaar Power, Jaipur. Estimates based on CPCB national data, Rajasthan population share (~5–6% of India), and EV adoption trends. Three scenarios: Conservative (1% battery share of e-waste), Moderate (3%), High (5%).
          </p>
        </div>
      </section>

      {/* VALUE CHAIN */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Revenue Model</div>
          <h2 className="section-title display">Where the Value Is</h2>
          <p className="section-body">
            Battery recycling generates value at every stage. Our 5 MTD facility (up to Black Mass stage) is projected to generate ₹54.87 Crore gross annual income at full capacity, with EBITDA of ₹14.41 Crore.
          </p>

          <div className="value-chain reveal">
            {[
              { icon: <BatteryIcon size={28} />, source: "Black Mass Sales", rate: "₹500–600/kg", desc: "Black Mass — the high-value powder containing Li, Co, Ni, Mn — is the primary revenue stream at approximately 50% by weight of processed batteries. At 2,500 kg/day output and ₹600/kg, this alone generates ₹45 Crore annually at full capacity." },
              { icon: <ScaleIcon size={28} />, source: "Copper Foil Recovery", rate: "₹650–850/kg", desc: "Copper current collectors separated during shredding and recovered as clean foil. At ~5% of input weight (400 kg/day), copper sales generate approximately ₹7.8 Crore annually. Sold to domestic smelters." },
              { icon: <CycleIcon size={28} />, source: "Aluminium Recovery", rate: "₹200–250/kg", desc: "Aluminium foils and casings separated via eddy current separators. At ~12% of input weight (400 kg/day), this generates approximately ₹1.44 Crore annually. Sold to domestic aluminium smelters." },
              { icon: <ChartIcon size={28} />, source: "EPR Certificate Services", rate: "Per-tonne fee", desc: "OEMs and producers pay a per-tonne processing and EPR certificate issuance fee. Surplus EPR certificates can also be traded to producers who cannot meet their own collection targets — an emerging secondary market under BWMR 2022." },
              { icon: <ShieldIcon size={28} />, source: "Plastics & Iron Recovery", rate: "₹15–35/kg", desc: "Separator plastics, casings, and steel components are separately recovered, sorted, and sold. Plastics at ~12% of input weight (750 kg/day) and iron at ~10% (450 kg/day) contribute a combined ₹63 lakh annually." },
            ].map((v) => (
              <div className="value-item" key={v.source}>
                <div className="value-icon">{v.icon}</div>
                <div>
                  <h4>{v.source} <span style={{ fontFamily: "'DM Mono', monospace", color: "var(--green)", fontSize: "0.85em", marginLeft: "0.5rem" }}>{v.rate}</span></h4>
                  <p>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINANCIAL SNAPSHOT */}
      <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Financial Snapshot — 5 MTD Facility</div>
          <h2 className="section-title display">The Numbers Stack Up</h2>
          <p className="section-body">
            Full financial projections from the Corpseed Detailed Project Report for our Jaipur plant. Capacity ramps from 30% in Year 1 to 100% by Year 4.
          </p>
          <div className="compare-table reveal" style={{ marginTop: "3rem" }}>
            <div className="compare-header">
              <div>Financial Metric</div>
              <div className="compare-col-header">Year 1 (30%)</div>
              <div className="compare-col-header">Year 3 (90%)</div>
              <div className="compare-col-header alankaar">Year 4–5 (100%)</div>
            </div>
            {[
              ["Gross Annual Income", "₹16.46 Cr", "₹49.38 Cr", "₹54.87 Cr"],
              ["OPEX", "₹12.14 Cr", "₹36.41 Cr", "₹40.46 Cr"],
              ["EBITDA (Pre-tax)", "₹4.32 Cr", "₹12.97 Cr", "₹14.41 Cr"],
              ["Net Profit (Post-tax)", "₹3.03 Cr", "₹9.08 Cr", "₹10.09 Cr"],
              ["ROI", "36.27%", "108.81%", "120.90%"],
              ["Break-even (Years)", "2.76", "0.92", "0.83"],
            ].map(([label, y1, y3, y5]) => (
              <div className="compare-row" key={label}>
                <div className="compare-label">{label}</div>
                <div className="compare-val">{y1}</div>
                <div className="compare-val">{y3}</div>
                <div className="compare-val pos">{y5}</div>
              </div>
            ))}
          </div>
          <p className="section-body" style={{ marginTop: "1.5rem", fontSize: "0.9rem", opacity: 0.7 }}>
            Total CAPEX: ₹8.34 Crore. Financing structure: ~20% GOI subsidy, 70% bank loan (12% interest), balance personal equity. Operating days: 300/year. Raw material assumed at ₹250/kg (market range: ₹150–1,000/kg by type). Black Mass output: ~50% by weight of input at ₹600/kg.
          </p>
        </div>
      </section>

      {/* POSITIONING */}
      <section>
        <div className="section-inner">
          <div className="market-highlight" style={{ borderLeftColor: "var(--green)", maxWidth: "750px" }}>
            Government EPR regulations now make battery recycling mandatory for every producer in India — every OEM legally requires a certified recycling partner. <strong>That partner is us.</strong>
          </div>
          <p className="section-body" style={{ marginTop: "2rem" }}>
            We are not chasing a speculative future market. The regulatory mandate is live and enforcing. The waste stream is building quarter by quarter. The mineral value is real and priced. Alankaar Power is positioned at the intersection of all three — with the processing capacity, compliance credentials, and operational infrastructure already in place to capture it.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section style={{ borderTop: "var(--accent-line)" }}>
        <div className="section-inner" style={{ textAlign: "center" }}>
          <h2 className="section-title display">Invest in India's<br />Circular Future</h2>
          <p className="section-body" style={{ margin: "0 auto 2rem" }}>
            Whether you're an investor, an OEM, or a technology partner — the time to act is now.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/#contact" className="btn-primary">Talk to Us</a>
            <Link to="/" className="btn-outline">← Back to Home</Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default MarketPage;
